import * as React from 'react';
import * as types from 'modules/types/smSupplierManagement';
import { CertificateAttachment } from 'modules/types/commons/file';
import { QuerySelectorHTMLElement } from 'modules/types/commons/dom';
import { Row, Col, Card, Button, NoData } from '@beehive/components';
import { LightBox } from 'components';
import { ifPicSuffix, prettyBytes } from 'utils';
import PropTypes from 'prop-types';
import globalMessages from 'messages';
import titleMessages from 'messages/CompanyManagement/CardTitle';
import _ from 'lodash';

const messages = { ...globalMessages, ...titleMessages };

interface QualifiedFileShow {
  imgArr: any[];
  handlePicClick: Function;
  loading?: boolean;
  hasDirtyAttrs?: boolean;
  getAttachementDownloadLink: (atachId: number, withDownload?: boolean) => string;
}

const QualifiedFileShow: React.SFC<QualifiedFileShow> = (props, context) => {
  const { intl } = context;
  const { imgArr, handlePicClick, hasDirtyAttrs = false, getAttachementDownloadLink } = props;
  let title = intl.formatMessage(messages.qualifiedFile);
  if (hasDirtyAttrs) {
    title = <span className="color-red">{title}</span>;
  }
  return (
    <Card
      titleNode={title}
      className="qualified-file-show"
      loading={props.loading}
    >
      <div className="qualified-files">
        {
          !!imgArr.length ? (
            <Row gutter={16}>
              {
                imgArr.map((item, index) => {
                  const imgStyle = item.url ? { backgroundImage: 'url(' + item.url + ')' } : {};
                  return (
                    <Col sm={12} xl={6} key={index}>
                      <a
                        className={`item-file ${item.ifPic ? 'pic' : ''}`}
                        style={imgStyle}
                        href={getAttachementDownloadLink(item.id)}
                        target="_blank"
                        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => handlePicClick(e, index, item)}
                      >
                        {!item.url && <div className="not-preview-file" />}
                        <div className="pic-mess"><span title={item.name}>{item.name}</span></div>
                      </a>
                      <div className="item-mess">
                        <Button href={getAttachementDownloadLink(item.id)} target="_blank">
                          {intl.formatMessage(messages.download)}
                        </Button>
                        <span>{intl.formatMessage(messages.bracketsWrap, { content: item.size })}</span>
                      </div>
                    </Col>
                  );
                })
              }
            </Row>
          ) : (
              <NoData type="empty" />
            )
        }
      </div>
    </Card>
  );
};

QualifiedFileShow.contextTypes = {
  intl: PropTypes.object,
};

interface QualifiedFileProps extends types.SupplierMangementDetail {
  getAttachementDownloadLink: (atachId: number, withDownload?: boolean) => string;
}

class QualifiedFile extends React.Component<QualifiedFileProps, any> {

  public static contextTypes = {
    intl: PropTypes.object,
  };

  constructor(props: QualifiedFileProps) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }

  public componentDidMount() {
    window.addEventListener('resize', this.setCardHeight);
    this.setCardHeight();
  }

  public componentDidUpdate() {
    this.setCardHeight();
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.setCardHeight);
  }

  private getImageArr = (arr: CertificateAttachment[]) => {
    const { getAttachementDownloadLink } = this.props;
    let idx = 0;
    return arr
      .filter((item: CertificateAttachment) => item.status !== 'removed')
      .map((item: CertificateAttachment) => {
        return {
          id: item.cert_attach.id,
          name: item.cert_attach.blob.filename,
          size: prettyBytes(item.cert_attach.blob.byte_size || 0, {}),
          url:
            ifPicSuffix(item.cert_attach.blob.filename)
              // @ts-ignore
              ? getAttachementDownloadLink(item.cert_attach.id, false)
              : null,
          ifPic: ifPicSuffix(item.cert_attach.blob.filename) ? true : false,
          //  非图片文件不计入lightbox的图片数组
          filterIdx: ifPicSuffix(item.cert_attach.blob.filename) ? idx++ : null,
        };
      });
  }

  //  管理lightBox的func
  private handlePicClick = (e: React.MouseEvent<HTMLAnchorElement>, idx: number, item: any): void => {
    if (item.ifPic) {
      e.preventDefault();
      const curIdx = item.filterIdx !== null ? item.filterIdx : idx;
      this.setState({ photoIndex: curIdx, isOpen: true });
    }
  }

  private handleClose = () => {
    this.setState({ photoIndex: 0, isOpen: false });
  }

  private handleOperateRequest = (photoIndex: number, imagesLen: number, pre: boolean) => {
    const temp = pre ? (-1) : 1;
    this.setState({ photoIndex: (photoIndex + imagesLen + temp) % imagesLen });
  }

  private setCardHeight() {
    //  qualifiedFile 图片动态高度
    const baseInfoElement: QuerySelectorHTMLElement =
      document.querySelector('.beehive-card.basic-info-show .beehive-card-content');
    const qualifiedFileElement: QuerySelectorHTMLElement =
      document.querySelector('.beehive-card.qualified-file-show .qualified-files');
    if (baseInfoElement && qualifiedFileElement) {
      const baseInfoHeight = baseInfoElement.clientHeight;
      const paddingHeight = 24;  //  资质文件padding大小
      qualifiedFileElement.style.height = `${baseInfoHeight - 2 * paddingHeight}px`;
    }
  }

  public render() {
    const { isOpen, photoIndex } = this.state;
    const { supplier_attaches: attachs = [], loading, getAttachementDownloadLink } = this.props;
    const images = this.getImageArr(attachs);
    const hasDirtyAttrs = _.get(this.props, 'dirty_attrs.supplier_attaches', false);
    return (
      <div className="qualified-file-outter">
        <QualifiedFileShow
          imgArr={images}
          handlePicClick={this.handlePicClick}
          loading={loading}
          hasDirtyAttrs={hasDirtyAttrs}
          getAttachementDownloadLink={getAttachementDownloadLink}
        />
        <LightBox
          isOpen={isOpen}
          images={images.filter((item: any) => item.ifPic)}
          photoIndex={photoIndex}
          handleClose={this.handleClose}
          handleOperateRequest={this.handleOperateRequest}
        />
      </div>
    );
  }
}

export default QualifiedFile;
